import React, { memo } from 'react';
import styled from 'styled-components';
import { Chip } from '@mic3/platform-ui';

const ChipBase = styled(Chip)`
    && {
        box-sizing: border-box;
        background-color: ${({ theme }) => theme.material.colors.background.chipClosed};
        font-weight: 500;
        text-transform: uppercase;
        font-size: 8px;

        height: 20px;
        padding: 6px 8px;

        border-radius: 100px;
        margin-left: 8px;

        color: ${({ theme }) => theme.material.colors.text.button};

        .MuiChip-label {
            padding: 0;
            line-height: 8px;
        }
    }
`;

const ChipClosed = ({ ...otherProps }) => {
    return <ChipBase {...otherProps} label={otherProps.label || 'Closed'} size="small" />;
};

export default memo(ChipClosed);
